import styled from 'styled-components';

export const StyledContainer = styled.section``;
